angular.module('picmonicng').directive('plsListItem', [
  function () {
    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      scope: {
        title: '@',
        image: '@',
        description: '@',
        picmonic: '=',
        index: '=',
        pathway: '=',
        playlist: '=',
        playlistPicmonics: '=',
        last: '=',
        sortMethod: '=',
        ltiSelection: '@',
      },
      templateUrl: '/templates/directives/pls-list-item.html',
      controller: [
        '$scope',
        '$filter',
        'MarketOptionsConfig',
        'UserService',
        'LearnService',
        function ($scope, $filter, MarketOptionsConfig, UserService, LearnService) {
          $scope.LearnService = LearnService;
          $scope.generateBreadCrumbs = function (item) {
            var buffer = '';
            var arrow_right = ' &rsaquo; ';
            var title =
              item.name ||
              item.track_name ||
              item.tertiary_pathway_name ||
              item.secondary_pathway_name ||
              item.pathway_name;

            if (item.pathway_type) {
              if (UserService.user && UserService.user.lead) {
                var config = MarketOptionsConfig.getMarketById(UserService.user.lead);
                var found = false;
                angular.forEach(config.sections, function (section) {
                  if (section.pathway_type == item.pathway_type && section.curriculum == item.curriculum && !found) {
                    buffer += $filter('ucfirst')(section.name);
                    found = true;
                  }
                });
              } else {
                buffer += $filter('ucfirst')(item.pathway_type);
              }
            }

            if (item.pathway_name) {
              if (buffer.length) {
                buffer += arrow_right;
              }
              buffer += item.pathway_name;
            }

            if (item.secondary_pathway_name && item.secondary_pathway_id != item.pathway_id) {
              if (buffer.length) {
                buffer += arrow_right;
              }
              buffer += item.secondary_pathway_name;
            }

            if (item.tertiary_pathway_name && item.tertiary_pathway_name != title) {
              if (buffer.length) {
                buffer += arrow_right;
              }
              buffer += item.tertiary_pathway_name;
            }

            if (item.track_name && item.track_name != title) {
              if (buffer.length) {
                buffer += arrow_right;
              }
              buffer += item.track_name;
            }

            return buffer;
          };
        },
      ],
      link: function (scope, element, attrs) {},
    };
  },
]);
